import React from "react";
import { useNavigate } from "react-router-dom";

const Hero = () => {

    const navigate = useNavigate();
    
    return(
        <>
            <div className="frame">
            <div className="overlay"></div>
            <div className="container top content">
                <div className="col-md-6">
                <p style={{color: '#F29235', fontWeight: '700'}}>
                    SERVICES / WEB DEVELOPMENT
                </p>

                <h1 className="mt-4 fw-bold" style={{fontSize: '48px'}}>
                    Scalable, High- <br />
                    performance
                    <span style={{color: '#F29235', lineHeight: '70px'}}>
                    <br /> Websites.
                    </span>
                </h1>
                <p className="mt-4">
                    We build modern B2B digital solutions that drive growth and technical excellence,
                    From custom CMS to complex enterprise web apps
                </p>

                <button className="butt" onClick={() => navigate("/start-project")}>Start your Project</button>
                </div>
            </div>
            </div>

        </>
    )
}

export default Hero;